var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_container"},[_vm._t("bottom_btn",function(){return [_c('button',{staticClass:"primary_btn",attrs:{"slot":"bottom_btn"},slot:"bottom_btn"},[_vm._v(" default ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }